/**
 * Closable components.
 *
 * Hide an element on close button click.
 */

(() => {
  'use-strict';

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;
      // Get all close buttons children
      const buttons = element.querySelectorAll('.js-close-button');

      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          event.preventDefault();
          /// Hide closable wrapper with smooth effect
          element.style.height = 'var(--height, auto)';
          element.style.setProperty('--height', `${element.scrollHeight}px`);
          setTimeout(() => {
            element.classList.add('-isClosing');
          }, 1);
          element.addEventListener('transitionend', () => {
            element.remove();
          });
        });
      });
    });
  }

  Drupal.behaviors.closableElements = {
    attach: () => {
      if (document.querySelectorAll('.js-closable').length !== 0) {
        init(document.querySelectorAll('.js-closable'));
      }
    },
  };
})();
